import { render, staticRenderFns } from "./VObsPrismIcon.vue?vue&type=template&id=1baa5503&scoped=true"
import script from "./VObsPrismIcon.vue?vue&type=script&lang=js"
export * from "./VObsPrismIcon.vue?vue&type=script&lang=js"
import style0 from "./VObsPrismIcon.vue?vue&type=style&index=0&id=1baa5503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa5503",
  null
  
)

export default component.exports